import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import type { SerieFacturacion } from '../models/factura.model';
import { createCachedObservable } from '../utils/cached-observable.util';

interface SeriesResponse {
  data: SerieFacturacion[];
}

@Injectable({ providedIn: 'root' })
export class SeriesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private readonly seriesCache = createCachedObservable(() =>
    this.http
      .get<SeriesResponse>(`${this.baseUrl}/series`)
      .pipe(map((res) => res.data ?? [])),
  );

  /** GET /api/series (caché en memoria). */
  getSeries(): Observable<SerieFacturacion[]> {
    return this.seriesCache.get();
  }

  clearSeriesCache(): void {
    this.seriesCache.clear();
  }
}
